import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      position="bottom-center"
      className="toaster group"
      style={{ zIndex: 99999 }}
      offset={80}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#0F172A] group-[.toaster]:border-[#E2E8F0] group-[.toaster]:shadow-xl group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-[#64748B]",
          actionButton:
            "group-[.toast]:bg-[#4338CA] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#F1F5F9] group-[.toast]:text-[#475569]",
          success:
            "group-[.toaster]:!bg-[#059669] group-[.toaster]:!text-white group-[.toaster]:!border-[#047857]",
          error:
            "group-[.toaster]:!bg-[#DC2626] group-[.toaster]:!text-white group-[.toaster]:!border-[#B91C1C]",
          info:
            "group-[.toaster]:!bg-[#4338CA] group-[.toaster]:!text-white group-[.toaster]:!border-[#3730A3]",
          warning:
            "group-[.toaster]:!bg-[#D97706] group-[.toaster]:!text-white group-[.toaster]:!border-[#B45309]",
        },
        duration: 2000,
      }}
      {...props} />
  );
}

export { Toaster, toast }
